/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { useEffect, useState } from 'react';
import E from 'wangeditor';
import EditorConfig from './RichTextConfig';
import styles from './RichText.module.less';
import { createAxios } from '../../../utils/utils';
import { FORUM_UPLOAD_PARAMS_72 } from '../../../config';
import 'whatwg-fetch';
import Toast from '../../Toast/Toast';

export default props => {
  const [node, setNode] = useState(null);
  const { menus, getUploadParams, validate, fontFamily } = EditorConfig;
  const [editorNode, setEditorNode] = useState(null);
  const [editorLen, setEditorLen] = useState(0);
  const [editorFocus, setEditorFocus] = useState(false);
  const {
    required,
    height = 300,
    placeholder = '请输入内容',
    className,
    maxLen = 1500,
    validate: validateText,
    validateInfo = {},
    defaultValue = null,
  } = props;

  const validateSizeOrRequired = (html, len) => {
    if (required && !html) {
      return validateInfo.required;
    }

    if (maxLen && len > maxLen) {
      return validateInfo.size;
    }
    return null;
  };
  useEffect(() => {
    if (editorNode) {
      validateText(validateSizeOrRequired(defaultValue, 0));
    }
  }, [editorNode]); // 初始化验证
  useEffect(() => {
    if (node) {
      const editor = new E(node);
      editor.config.menus = menus;
      editor.config.showLinkImg = false;
      editor.config.showFullScreen = false;
      editor.config.height = height;
      editor.config.placeholder = placeholder;
      editor.config.zIndex = 2;
      editor.config.fontNames = fontFamily;
      // editor.config.colors = ['#999', '#333', '#000'];
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024;
      // editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      editor.config.uploadImgAccept = [];
      editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
        // 验证上传结果是否符合要求
        const validateResult = await validate(resultFiles[0]);

        if (!validateResult) {
          return;
        }
        // 获取上传图片的凭证
        const axios = await createAxios();
        const result = await axios.get(FORUM_UPLOAD_PARAMS_72);
        let ossParams = null;
        let insertResult = null; // 上传图片的结果
        try {
          const {
            data: { status, data },
          } = result;
          if (status === 0) {
            // resultFiles 是 input 中选中的文件列表
            const uploadParams = getUploadParams({ file: resultFiles[0], ...data });
            ossParams = {
              ...data,
              ...uploadParams,
            };
            const formdatas = new FormData();
            for (const key in uploadParams) {
              formdatas.append(key, uploadParams[key]);
            }
            formdatas.append('file', resultFiles[0]);
            insertResult = await window.fetch(data.host, {
              method: 'POST',
              body: formdatas,
            });
          } else {
            Toast.error({
              content: '上传图片的失败',
            });
          }
        } catch (err) {}
        // 插入图片的url
        try {
          const { status: resStatus } = insertResult;
          if (resStatus === 200) {
            insertImgFn(`${ossParams.imgPrefix}/${ossParams.key}`);
          }
        } catch (err) {
          Toast.error({
            content: '上传图片的失败',
          });
        }
      };

      editor.config.onfocus = () => {
        setEditorFocus(true);
      };
      editor.config.onblur = () => {
        setEditorFocus(false);
      };
      editor.config.onchange = () => {
        const content = editor && editor.txt && editor.txt.text && editor.txt.text();
        const html = editor && editor.txt && editor.txt.html && editor.txt.html();
        setEditorLen((content && content.length) || 0);
        // eslint-disable-next-line no-unused-expressions
        validateText &&
          validateText(validateSizeOrRequired(html, (content && content.length) || 0)); // 返回验证结果
      };
      // 自定义失败提示
      editor.config.customAlert = (s, t) => {
        Toast.error({
          content: t,
        });
      };

      editor.create();
      setEditorNode(editor);
    }
  }, [node]);

  useEffect(() => {
    if (editorNode && placeholder) {
      try {
        const el = document.querySelector(`div[data-we-id=${editorNode.id}]`);
        const placeholderEl = el.getElementsByClassName('placeholder');
        if (placeholderEl && placeholderEl[0]) {
          placeholderEl[0].innerHTML = placeholder;
        }
      } catch (err) {}
    }
  }, [placeholder, editorNode]);

  useEffect(() => {
    const { initRichText } = props;
    if (editorNode && initRichText) {
      initRichText(editorNode);
    }
  }, [editorNode]);

  return (
    <div className={styles.editor_container}>
      <div
        className={`${className || styles.editor} ${editorFocus ? styles.editor_focus : ''}`}
        ref={r => setNode(r)}
      ></div>
      {(!placeholder ||
        (editorNode && editorNode.txt && editorNode.txt.html && editorNode.txt.html())) &&
        maxLen && (
          <div className={styles.editor_count}>
            <span className={editorLen > maxLen ? styles.danger_tip : ''}>{editorLen}</span>/
            {maxLen}
          </div>
        )}
    </div>
  );
};
